// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MFYmTNIONUaPNQiBfKHd {
  display: flex;
  position: relative;
  width: 100%;
  overflow: hidden;
}
.sSqulYiwXKTWqjiFUadQ {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  overflow-x: auto;
  overflow-y: visible;
  overscroll-behavior-x: none;
  overscroll-behavior-y: auto;
  gap: 8px;
  padding: 0 0 14px;
  width: 100%;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  scrollbar-color: var(--border-light) var(--cardBackground);
  /* To hide scrollbar on some iOS devices */
}
.sSqulYiwXKTWqjiFUadQ::-webkit-scrollbar {
  display: none;
}
@media (orientation: landscape) {
  .sSqulYiwXKTWqjiFUadQ {
    padding: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/MultiViewCampaignSection/components/CampaignGamesGrid/CampaignGamesGrid.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;EAC3B,QAAQ;EACR,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB;EACrB,0DAA0D;EAC1D,0CAA0C;AAC5C;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".scrollableCampaignGridWrapper {\n  display: flex;\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.campaignGamesGrid {\n  position: relative;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  overflow-x: auto;\n  overflow-y: visible;\n  overscroll-behavior-x: none;\n  overscroll-behavior-y: auto;\n  gap: 8px;\n  padding: 0 0 14px;\n  width: 100%;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  scrollbar-color: var(--border-light) var(--cardBackground);\n  /* To hide scrollbar on some iOS devices */\n}\n.campaignGamesGrid::-webkit-scrollbar {\n  display: none;\n}\n@media (orientation: landscape) {\n  .campaignGamesGrid {\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollableCampaignGridWrapper": `MFYmTNIONUaPNQiBfKHd`,
	"campaignGamesGrid": `sSqulYiwXKTWqjiFUadQ`
};
export default ___CSS_LOADER_EXPORT___;
